/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output, signal} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {NgForm} from '@angular/forms';
import * as _ from 'lodash';

import template from './order-quick-line-item-form.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {Uuid} from '../../components/util/uuid';
import {LineItemApiService} from '../line-item/line-item-api.service';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-order-quick-line-item-form',
  template
})
export class OrderQuickLineItemFormComponent {
  @Input() lineItem: any;
  @Input() isAxAdvertiser = false;
  @Input() objectiveFields: any = {};
  @Input() bidSpecificationFields: any = {};
  @Input() lineItemObjectivesAsStringFn: () => string = () => '';
  @Input() beforeSave: () => void = () => undefined;

  @Output() saved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<void>();

  readonly submitting = signal(false);
  readonly apiErrors = signal<string[]>([]);

  constructor(
    private readonly lineItemApi: LineItemApiService,
  ) {
  }

  lineItemObjectivesAsString(): string {
    return this.lineItemObjectivesAsStringFn();
  }

  submitLineItem(form: NgForm): void {
    if (form.invalid || this.submitting()) {
      return;
    }

    this.submitting.set(true);
    this.apiErrors.set([]);
    this.beforeSave();

    if (!this.lineItem.id) {
      this.lineItem.id = Uuid.generate();
    }

    const qStrings: any = {};
    if (_.get(this.lineItem, ['ignoreProduct'])) {
      qStrings.ignoreProduct = true;
    }

    firstValueFrom(this.lineItemApi.savePartial(this.lineItem, undefined, qStrings)).then((savedItem: any) => {
      this.submitting.set(false);
      form.resetForm();
      this.saved.emit(savedItem);
    }, (response: any) => {
      this.submitting.set(false);
      if ((response.status === 400 || response.status === 422) && response.data?.errors) {
        this.apiErrors.set(_.map(response.data.errors, (e: any) => e.text || e.code || 'Validation error'));
      }
    });
  }

  cancelForm(): void {
    this.cancelled.emit();
  }
}
